/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * WFM-Backend
 * OpenAPI spec version: 1
 */

export type VideoMode = typeof VideoMode[keyof typeof VideoMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoMode = {
  OFFLINE: 'OFFLINE',
  LIVE: 'LIVE',
  FRAME: 'FRAME',
} as const;
